export enum AppointmentType {
  ImportPickUp = "PUI",
  ExportDropOff = "DOE",
  ContainerEventHistory = "CEH",
  VesselSchedule = "VS"
}

export enum AppointmentTypeLabels {
  "PUI" = "Import availability",
  "DOE" = "Export enquiry",
  "CEH" = "Container event history",
  "VS" = "Vessel schedule"
}

export enum TransactionTypeIcons {
  "PUI" = "container-up",
  "DOE" = "container-down",
  "CEH" = "container-tracking",
  "VS" = "vessel-front"
}
